module.exports = "//static.hsappstatic.net/LoginUI/static-1.15413/img/donut_mobile.svg"